import { Link } from "react-router-dom";

const Footer = () => {
  const specialties = [
    { name: "Heart Doctor", slug: "heart-doctor", path: "/find-a-doctor/heart-doctor" },
    { name: "Skin Doctor", slug: "skin-doctor", path: "/find-a-doctor/skin-doctor" },
    { name: "Children's Doctor", slug: "childrens-doctor", path: "/find-a-doctor/childrens-doctor" },
    { name: "Mental Health Doctor", slug: "anxiety-doctor", path: "/find-a-doctor/anxiety-doctor" },
    { name: "Bone Doctor", slug: "knee-doctor", path: "/find-a-doctor/knee-doctor" },
    { name: "Family Doctor", slug: "family-doctor", path: "/find-a-doctor/family-doctor" },
  ];

  const states = [
    { code: "CA", name: "California" },
    { code: "TX", name: "Texas" },
    { code: "FL", name: "Florida" },
    { code: "NY", name: "New York" },
    { code: "PA", name: "Pennsylvania" },
    { code: "IL", name: "Illinois" },
  ];

  return (
    <footer className="bg-slate-50 border-t border-slate-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="font-display font-bold text-xl text-navy mb-4">
              NPI Lookup
            </div>
            <p className="text-sm text-slate-500 leading-relaxed">
              The fastest way to verify any US healthcare provider. Search over 6.2 million registered providers instantly.
            </p>
          </div>

          {/* Specialties */}
          <div className="col-span-1">
            <h4 className="font-display font-semibold text-slate-900 mb-4">
              Popular Specialties
            </h4>
            <ul className="space-y-2">
              {specialties.map((specialty) => (
                <li key={specialty.slug}>
                  <Link
                    to={specialty.path}
                    className="text-sm text-slate-500 hover:text-teal transition-colors"
                    data-testid={`footer-specialty-${specialty.slug}`}
                  >
                    {specialty.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/specialties"
                  className="text-sm text-teal font-medium hover:underline"
                  data-testid="footer-all-specialties"
                >
                  View All Specialties
                </Link>
              </li>
            </ul>
          </div>

          {/* States */}
          <div className="col-span-1">
            <h4 className="font-display font-semibold text-slate-900 mb-4">
              Browse by State
            </h4>
            <ul className="space-y-2">
              {states.map((state) => (
                <li key={state.code}>
                  <Link
                    to={`/state/${state.code}`}
                    className="text-sm text-slate-500 hover:text-teal transition-colors"
                    data-testid={`footer-state-${state.code}`}
                  >
                    {state.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/states"
                  className="text-sm text-teal font-medium hover:underline"
                  data-testid="footer-all-states"
                >
                  View All States
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="col-span-1">
            <h4 className="font-display font-semibold text-slate-900 mb-4">
              Tools & Resources
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/find-a-doctor"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                  data-testid="footer-find-doctor"
                >
                  Find a Doctor
                </Link>
              </li>
              <li>
                <Link
                  to="/directory"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                  data-testid="footer-directory"
                >
                  Full Directory
                </Link>
              </li>
              <li>
                <Link
                  to="/dea-npi-lookup"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                >
                  DEA Number Lookup
                </Link>
              </li>
              <li>
                <Link
                  to="/verify"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                >
                  Verification Report
                </Link>
              </li>
              <li>
                <Link
                  to="/pecos-lookup"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                  data-testid="footer-pecos"
                >
                  PECOS Lookup
                </Link>
              </li>
              <li>
                <Link
                  to="/oig-exclusion-lookup"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                  data-testid="footer-oig"
                >
                  OIG Exclusion Lookup
                </Link>
              </li>
              <li>
                <Link
                  to="/bulk-screening"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                  data-testid="footer-bulk-screening"
                >
                  Bulk Compliance Screening
                </Link>
              </li>
              <li>
                <Link
                  to="/recently-verified"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                  data-testid="footer-recently-verified"
                >
                  Recently Verified
                </Link>
              </li>
              <li>
                <Link
                  to="/near-me"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                >
                  Doctors Near Me
                </Link>
              </li>
              <li>
                <a
                  href="https://npiregistry.cms.hhs.gov/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-slate-500 hover:text-teal transition-colors"
                >
                  Official NPI Registry
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-slate-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-slate-400">
              Data sourced from the official CMS NPI Registry. This site is not affiliated with CMS or HHS.
            </p>
            <p className="text-xs text-slate-400">
              © {new Date().getFullYear()} NPI Lookup. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
